import PublicMain from '@/views/public/PublicMain.vue'

const routes = [
  {
    path: '/login',
    component: PublicMain,
    meta: { isPublic: true },

    children: [
      {
        path: '/',
        name: 'login',
        component: () =>
          import(/* webpackChunkName: 'public' */ '@/views/public/Login.vue'),
        meta: { isPublic: true }
      },

      {
        path: '/signup',
        name: 'signup',
        component: () =>
          import(/* webpackChunkName: 'public' */ '@/views/public/Signup.vue'),
        meta: { isPublic: true }
      },

      {
        path: '/signup/success',
        name: 'signup-success',
        component: () =>
          import(
            /* webpackChunkName: 'public' */ '@/views/public/SignupSuccess.vue'
          ),
        meta: { isPublic: true }
      },

      {
        path: '/verify',
        name: 'verify',
        component: () =>
          import(/* webpackChunkName: 'public' */ '@/views/public/Verify.vue'),
        meta: { isPublic: true }
      },

      {
        path: '/reset',
        name: 'reset',
        component: () =>
          import(/* webpackChunkName: 'public' */ '@/views/public/Reset.vue'),
        meta: { isPublic: true }
      },

      {
        path: '/password',
        name: 'set-password',
        component: () =>
          import(
            /* webpackChunkName: 'public' */ '@/views/public/SetPassword.vue'
          ),
        meta: { isPublic: true }
      }
    ]
  }
]

export default routes
